module.exports = __webpack_public_path__ + "img/apply_no.a9e8a306.png";